import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

interface RecommendationsCoursesProps {
  desktopColumns?: number;
  tabletColumns?: number;
  mobileColumns?: number;
}

export const StyledRecommendationsContainer = styled.div`
  .recommendations-header,
  .recommendations-description {
    p {
      margin-bottom: 0;
    }
  }

  .recommendations-container {
    padding-left: ${toRem(16)};
    padding-right: ${toRem(16)};

    @media ${baseVariables.mediaQuery.md},
      @media ${baseVariables.mediaQuery.lg},
      @media ${baseVariables.mediaQuery.xl} {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const StyledRecommendationsCourses = styled.div<RecommendationsCoursesProps>`
  display: grid;
  gap: ${toRem(16)};
  grid-template-columns: ${props => (props?.mobileColumns ? `repeat(${props?.mobileColumns}, 1fr)` : 'repeat(1, 1fr)')};

  @media ${baseVariables.mediaQuery.md} {
    grid-template-columns: ${props =>
      props?.tabletColumns ? `repeat(${props?.tabletColumns}, 1fr)` : 'repeat(2, 1fr)'};
  }

  @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    gap: ${toRem(24)};
    grid-template-columns: ${props =>
      props?.desktopColumns ? `repeat(${props?.desktopColumns}, 1fr)` : 'repeat(3, 1fr)'};
  }
`;
